<template>
  <div class="acomodar">
    <button class="btn btn-danger mx-4 my-2" @click="retroceder">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="26"
        height="26"
        fill="currentColor"
        class="bi bi-skip-backward"
        viewBox="0 0 16 16"
      >
        <path
          d="M.5 3.5A.5.5 0 0 1 1 4v3.248l6.267-3.636c.52-.302 1.233.043 1.233.696v2.94l6.267-3.636c.52-.302 1.233.043 1.233.696v7.384c0 .653-.713.998-1.233.696L8.5 8.752v2.94c0 .653-.713.998-1.233.696L1 8.752V12a.5.5 0 0 1-1 0V4a.5.5 0 0 1 .5-.5zm7 1.133L1.696 8 7.5 11.367V4.633zm7.5 0L9.196 8 15 11.367V4.633z"
        />
      </svg>
      RETROCEDER
    </button>

    <h2 class="mx-4 mt-2 text-secondary">ETAPA ENTREVISTA:</h2>
    <div class="card bg-solimano pb-3 mt-3 mx-4">
      <div class="col-12">
        <b-alert show variant="danger" v-if="alertaError"
          ><a href="#" class="alert-link"
            >tienes que ingresar todos los campos</a
          ></b-alert
        >
        <b-alert
          :show="dismissCountDown"
          variant="success"
          @dismissed="dismissCountDown = 0"
          @dismiss-count-down="countDownChanged"
        >
          Grabando ... {{ dismissCountDown }} segundos
        </b-alert>
      </div>

      <form action="" @submit.prevent="GrabarEntrevista">
        <div class="row gx-4 gy-2 px-5 card-body">
          <h4 class="mt-2 titulo mb-3">Entrevista</h4>
          <div class="col-lg-3 col-md-6">
            <label for="exampleInputEmail1" class="tamaño"
              >tipo de entrevista:</label
            >
            <select
              class="form-select mt-2"
              aria-label="Default select example"
              @change="EscogerEntrevistador($event)"
              v-model="selected"
            >
              <option disabled value="seleccionar">Seleccionar tipo...</option>
              <option
                v-for="items in entrevista"
                :key="items.id"
                :value="items.parCorrelativo"
              >
                {{ items.parDescripcion }}
              </option>
            </select>
          </div>

          <div class="col-lg-3 col-md-6">
            <label for="exampleInputEmail1" class="tamaño"
              >Entrevistador:</label
            >
            <select
              class="form-select mt-2"
              aria-label="Default select example"
              @change="IdEntrevistador($event)"
              v-model="selected1"
            >
              <option disabled value="seleccionar1">
                Seleccionar Entrevistador...
              </option>
              <option
                v-for="entrevistadores in entrevistador"
                :key="entrevistadores.id"
                :value="entrevistadores.idTrabajador"
              >
                {{ entrevistadores.nombreTrabajador }}
              </option>
            </select>
          </div>
        </div>

        <div class="row gx-4 gy-2 px-5 card-body">
          <div class="col-lg-12">
            <label for="" class="tamaño"
              >Agenda y resultado de entrevista:</label
            >
            <textarea
              v-model="form.entrevistaResultado"
              class="form-control mt-2"
              placeholder="Escriba aqui el detalle de la entrevista"
              style="height: 100px"
            ></textarea>
          </div>

          <div class="col-lg-4 col-md-6">
            <label for="exampleInputEmail1" class="tamaño">Estado:</label>
            <select
              class="form-select mt-2"
              aria-label="Default select example"
              @change="EstadosParams($event)"
              v-model="selected2"
            >
              <option disabeld value="seleccionar2">
                Seleccionar estado...
              </option>
              <option
                v-for="estadosUnicos in estados"
                :key="estadosUnicos.id"
                :value="estadosUnicos.parCorrelativo"
              >
                {{ estadosUnicos.parDescripcion }}
              </option>
            </select>
          </div>

          <div class="d-flex justify-content-center mt-3">
            <button class="btn btn-success mx-2 mb-3 px-5 py-3">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="26"
                height="26"
                fill="currentColor"
                class="bi bi-save2 mx-2"
                viewBox="0 0 16 16"
              >
                <path
                  d="M2 1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H9.5a1 1 0 0 0-1 1v4.5h2a.5.5 0 0 1 .354.854l-2.5 2.5a.5.5 0 0 1-.708 0l-2.5-2.5A.5.5 0 0 1 5.5 6.5h2V2a2 2 0 0 1 2-2H14a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h2.5a.5.5 0 0 1 0 1H2z"
                />
              </svg>
              GRABAR ENTREVISTA
            </button>
          </div>
        </div>
      </form>
    </div>

    <!-- aqui vinee las tablas -->
    <div class="card card-body bg-solimano mx-4 my-3">
      <div class="d-flex justify-content-end mx-4 mb-4">
        <label for="" class="mt-4"> Buscar:</label>
        <input
          class="form-control form-control-lg w-25 mx-4 mt-3"
          type="text"
          placeholder="buscar por tipo de entrevista..."
          aria-label=".form-control-lg example"
          v-model="filterField"
        />
      </div>
      <div class="table-responsive">
        <table
          v-if="filterField.length <= 0 ? cerrarTable1 : !cerrarTable1"
          class="table table-bordered"
        >
          <thead>
            <tr class="bg-solimano-table text-white text-center tamaño2">
              <th scope="col">ID</th>
              <th scope="col">TIPO</th>
              <th scope="col">ENTREVISTADOR</th>
              <th scope="col">RESULADOR ENTREVISTA (FEEDBACK)</th>
              <th>ESTADO</th>
              <th v-if="cerrarPorSeguimiento">ACCION</th>
            </tr>
          </thead>
          <tbody
            v-for="(post, index) in posts.slice(NUM_RESULTS - 6, NUM_RESULTS)"
            :key="index.id"
          >
            <tr v-if="filterField.length < 1 ? true : false">
              <td>{{ post.idEntrevista }}</td>
              <td class="text-center">{{ post.entrevistaTipo }}</td>
              <td>{{ post.nomEntrevistador }}</td>
              <td>{{ post.entrevistaResultado }}</td>
              <td class="text-center">{{ post.entEstado }}</td>

              <td v-if="cerrarPorSeguimiento" class="text-center">
                <div class="mx-2">
                  <button
                    class="btn btn-danger"
                    @click="Eliminar(post.idEntrevista)"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-trash"
                      viewBox="0 0 16 16"
                    >
                      <path
                        d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"
                      />
                      <path
                        fill-rule="evenodd"
                        d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
                      />
                    </svg>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <div v-if="filterField.length > 0 ? !cerrarTable2 : cerrarTable2">
          <table class="table table-bordered">
            <thead>
              <tr class="bg-solimano-table text-white text-center tamaño2">
                <th scope="col">ID</th>
                <th scope="col">TIPO</th>
                <th scope="col">ENTREVISTADOR</th>
                <th scope="col">RESULADOR ENTREVISTA(FEEDBACK)</th>
                <th>ESTADO</th>
                <th v-if="cerrarPorSeguimiento">ACCION</th>
              </tr>
            </thead>
            <tbody v-for="(post, index) in posts" :key="index.id">
              <tr class="text-center" v-if="filter(post)">
                <td>{{ post.idEntrevista }}</td>
                <td class="text-center">{{ post.entrevistaTipo }}</td>
                <td>{{ post.nomEntrevistador }}</td>
                <td>{{ post.entrevistaResultado }}</td>
                <td class="text-center">{{ post.entEstado }}</td>
                <td v-if="cerrarPorSeguimiento" class="text-center">
                  <div class="mx-2">
                    <button class="btn btn-danger">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-pencil-fill"
                        viewBox="0 0 16 16"
                      >
                        <path
                          d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z"
                        />
                      </svg>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="d-flex mt-3">
        <button
          class="btn btn-dark mx-4"
          @click="retroceso"
          :disabled="noRetroceder"
        >
          <span aria-hidden="true">{{ retrocede }}</span>
        </button>
        <button
          class="px-3 rounded-2 py-2 btn-solimano text-white"
          :disabled="true"
        >
          {{ pag }}
        </button>
        <button
          class="btn btn-dark mx-4"
          @click="aumentar"
          :disabled="noAvanzar"
        >
          <span aria-hidden="true">{{ avanzar }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import swal from "sweetalert";
import { mapGetters } from "vuex";

export default {
  name: "SolimanologDatosEntrevista",

  data() {
    return {
      filterField: "",
      cerrarTable1: true,
      cerrarTable2: false,
      NUM_RESULTS: 6,
      pag: 1,
      noAvanzar: false,
      noRetroceder: false,
      cerrarPorSeguimiento: true,
      form: {
        idUsuario: "",
        idSolxPostulante: "",
        entrevistaTipo: "",
        entrevistaResultado: "",
        idEntrevistador: "",
        entEstado: "",
      },
      entrevista: [],
      entrevistador: [],
      estados: [],
      selected: "seleccionar",
      selected1: "seleccionar1",
      selected2: "seleccionar2",
      retrocede: "<<",
      avanzar: ">>",

      posts: [],
      alertaError: false,
      dismissSecs: 2,
      dismissCountDown: 0,
    };
  },

  mounted() {
    this.form.idUsuario = localStorage.getItem("userId");

    console.log(this.$route.params.ContratoEntre);
    this.form.idSolxPostulante = this.$route.params.ContratoEntre;
    console.log(this.$route.params.ContratoEntre);
    this.axios
      .get("Entrevista/ListaEntrevistaxPos/" + this.$route.params.ContratoEntre)
      .then((r) => {
        this.entrevista = r.data;
        // console.log(this.entrevista)
      });

    this.axios.get("ParametroData/Parametro/7523").then((r) => {
      this.estados = r.data;
      // console.log(r.data)
    });

    this.axios
      .get("Entrevista/ObtenerEntrevista/" + this.$route.params.ContratoEntre)
      .then((r) => {
        this.posts = r.data;
        console.log(this.posts);
      });
  },
  computed: {
    ...mapGetters("parametros", [
      "EstadoCiviles",
      "Genero",
      "Arreglar",
      "DepartamentoDistrito",
      "NacionEstado",
      "PaisEstado",
    ]),
    ...mapGetters("users", [
      "Items",
      "Permisos",
      "Contratos",
      "Tecnologia",
      "Operaciones",
      "Sst",
      "Bienestar",
      "Nominas",
      "Tesoreria",
      "Contabilidad",
      "Postulante",
    ]),
  },

  methods: {
    filter(items) {
      // aqui nos aseguramos que el input contenga caracteres String y que valida
      // el v-model de this.nombre
      console.log(items.idEntrevista);
      return (
        items.entEstado
          .toLocaleLowerCase()
          .indexOf(this.filterField.toLocaleLowerCase()) >= 0
      );
    },

    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs;
    },
    getAttributes() {
      this.axios
        .get("Entrevista/ObtenerEntrevista/" + this.$route.params.ContratoEntre)
        .then((r) => {
          this.posts = r.data;
          console.log(this.posts);
        });
    },
    Eliminar(id) {
      Swal.fire({
        title: "Estas seguro de Eliminar?",

        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si, Eliminar!!",
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire("¡Eliminado!", "El registrado ha sido eliminado con éxito", "success");
          this.axios
            .delete(
              `Entrevista/EliminarEntrevista?idEntrevista=${id}&idSolxPostulante=${this.form.idSolxPostulante}`
            )
            .then((r) => {
              console.log(r.data);
              this.getAttributes();
            });
        }
      });
    },

    retroceder() {
      window.history.back();
    },

    GrabarEntrevista() {
      console.log(this.form);

      if (
        this.form.idSolxPostulante == "" ||
        this.form.entrevistaTipo == "" ||
        this.form.entrevistaResultado == "" ||
        this.form.idEntrevistador == "" ||
        this.form.entEstado == ""
      ) {
        this.alertaError = true;
        setTimeout(() => {
          this.alertaError = false;
        }, 2500);
      } else {
        this.axios
          .post("Entrevista/RegistrarEntrevista", this.form)
          .then((r) => {
            if (r.data == true) {
              swal("Gracias", "Se Registro Entrevista!", "success");
              this.form.entrevistaResultado = "";
              (this.selected = "seleccionar"),
                (this.selected1 = "seleccionar1"),
                (this.selected2 = "seleccionar2"),
                (this.alertaError = false);
              this.getAttributes();
            }
          });
      }
    },
    EscogerEntrevistador(event) {
      console.log(event.target.value);
      this.form.entrevistaTipo = event.target.value;

      this.axios
        .get("Entrevista/ListaEntrevistaxRes/" + event.target.value)
        .then((r) => {
          this.entrevistador = r.data;
          //  console.log(r.data)
        });
    },

    IdEntrevistador(event) {
      this.form.idEntrevistador = event.target.value;
    },

    EstadosParams(event) {
      this.form.entEstado = event.target.value;
    },
    retroceso() {
      if (this.NUM_RESULTS === 6) {
        // this.retro = false;
        //  this.avanzar = true;
        this.noRetroceder = true;
      } else {
        // this.retro = true;
        this.NUM_RESULTS -= 6;
        this.pag -= 1;
        this.noAvanzar = false;
        this.noRetroceder = false;
        //  this.avanzar = true
      }
    },
    aumentar() {
      this.NUM_RESULTS += 6;
      this.pag += 1;
      if (this.NUM_RESULTS > 6) {
        this.noRetroceder = false;
      } else {
        this.noRetroceder = true;
      }
      if (this.NUM_RESULTS > this.posts.length) {
        this.noAvanzar = true;
      }
      // console.log(this.NUM_RESULTS);
    },
  },
};
</script>

<style scoped>
.acomodar {
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  margin-top: 15px;
  margin-bottom: 15px;
  width: 100%;
  background: rgb(255, 255, 255);
  margin-left: 2%;
  margin-right: 2%;
  height: 100vh;
  border-radius: 10px 10px 10px 10px;
  overflow-x: auto;
  overflow-y: none;
}

.tamaño {
  font-size: 0.65rem;

  font-weight: 800;
  color: #002c5d;
}

.tamaño2 {
  font-size: 0.65rem;
  font-weight: 800;
}

.titulo {
  color: #0080c8;
  text-decoration: underline;
}

.bg-solimano {
  border-color: #0080c8;
  border-width: 2px;
}

.bg-solimano-table {
  background: #0080c8;
}

.btn-solimano {
  background: #0080c8;
}
</style>
